export default "__VITE_ASSET__BaP87aep__"